import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

const iconSize = "h-[20px] w-[20px]";
const iconWeight = 1.6;

export function ThemeToggle() {
  const { setTheme, resolvedTheme: theme } = useTheme();

  return (
    <button onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
      {theme === "light" && (
        <Sun className={iconSize} strokeWidth={iconWeight} />
      )}
      {theme === "dark" && (
        <Moon className={iconSize} strokeWidth={iconWeight} />
      )}
    </button>
  );
}
